module.exports = __webpack_public_path__ + "static/product-pa50-32727ad3947287d372a1d42b9a37f255.png";